import { render, staticRenderFns } from "./PartnerShip.vue?vue&type=template&id=4ac77682&scoped=true&"
import script from "./PartnerShip.vue?vue&type=script&lang=js&"
export * from "./PartnerShip.vue?vue&type=script&lang=js&"
import style0 from "./PartnerShip.vue?vue&type=style&index=0&id=4ac77682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac77682",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VIcon,VRow,VSpacer})
